/**
 * @internal
 */
export const packageVersion = '22.6.4';
